import gdpr_de from "@/assets/texts/gdpr_de.txt";
import saas_agb_en from "@/assets/texts/saas_agb_en.txt";
import saas_services_en from "@/assets/texts/saas_services_en.txt";

export default {
    IconsLeft: 'Icon links',
    IconsRight: 'Icon rechts',
    removeLogo: 'Logo entfernen',
    versionIsTooOld: 'Das vSTAGE Projekt "{projectName}" mit der Version {version} ist zu alt. Bitte upgraden Sie das Projekt in der neusten Version von vSTAGE und versuchen Sie es noch einmal.',
    projectsUsage: 'Projekte in denen das Bauteil verwendet wird',
    Language: 'Sprache',
    editType: '{type} bearbeiten',
    forAllAssemblies: 'Für alle 3D-Objekte',
    forThisAssemblyOnly: 'Nur für diese 3D-Gruppe',
    AvailableExportProfiles: 'Verfügbare Export-Profile',
    noExportProfilesFound: 'Es wurden keine Export-Profile gefunden, prüfen Sie auch den globalen Filter im linken Menü.',
    AddAll: 'Alle hinzufügen',
    noMoreMetaFieldsToAdd: 'Es sind keine weiteren Meta-Felder verfügbar',
    clickToAddTeam: 'Klicken um ein Team hinzuzufügen',
    missingTeams: 'Fehlende Teams',
    projectInstanceMissingTeam: 'Das Objekt ist für mindestens ein Team nicht zugänglich.',
    editTeams: 'Teams bearbeiten',
    ProjectContent: 'Projekt-Inhalt',
    showDetails: 'Details anzeigen',
    selectedProject: 'Ausgewähltes Projekt',
    validateAsEmail: 'Nur Email-Adressen zulassen',
    vformPublishingDisabled: 'Das Veröffentlichen von Projekten ist nur auf Ihrer eigenen Webapp möglich. Im Control Center unter Apps können Sie eine erstellen',
    SharingOnlyWithvForm: 'Sharing funktioniert derzeit nur mit vForms',
    withLogin: 'Mit Login',
    withoutLogin: 'Ohne Login',
    WhitelistedWebsites: 'Whitelisted Webseiten',
    changewWhitelisting: 'Whitelisting ändern',
    ExplanationOfWhiteListing: 'Damit das Projekt als iFrame eingebunden werden kann, muss die aufrufende Webseite in der Whitelist stehen. Das ist ein Sicherheits-Feature, um Cross-Siting Attacks zu verhindern.',
    goToForm: 'Zum vForm gehen',
    projectModifications: 'Projektänderungen',
    UpdatedAt: 'Aktualisiert um',
    GeneratedLink: 'Spezifische Parameter verwenden',
    SetInitialSlide: 'Initiale Slide setzen',
    SetInitialStep: 'Initialen Step setzen',
    HideLoginWindow: 'Login-Fenster ausblenden',
    SetInitialLanguage: 'Initiale Sprache setzen',
    NeedToPublishFirst: 'Falls Sie diese Option nutzen möchten, müssen Sie zuerst Ihr Projekt veröffentlichen.',
    HideLoginWindowDescriptionPublished: 'Diese Option nur anwählen, wenn Sie sich auf anderem Weg authentifizieren als das Login-Fenster. Ansonsten wird der Link nicht funktionieren.',
    PublishedVersion: 'Veröffentlichtes Projekt',
    PublishedVersionDescription: 'Die veröffentlichte Version ist ohne Login für alle zugänglich, die den Link kennen.',
    GenerateYourLink: 'Links',
    Details: 'Details',
    play: 'play',
    Play: 'Play',
    currentSlideId: 'Aktuelle Slide ID',
    currentSlideIndex: 'Aktueller Slide Index',
    currentStepId: 'Aktuelle Step ID',
    licenses: 'Lizenzen',
    appPanel: 'App Panel',
    none: 'Keine',
    private: 'Privat',
    manager: 'Manager',
    admin: 'Administrator',
    viewer: 'Viewer',
    editor: 'Editor',
    Team: 'Team',
    teams: 'Teams',
    role: 'Rolle',
    showGraph: 'Graph anzeigen',
    noTeamsAssigned: 'Es sind keine Teams zugewiesen',
    noTagsAvailable: 'Es sind keine Tags verfügbar',
    noTagsYet: 'Es gibt noch keinen Tag mit diesem Namen, möchten Sie einen erstellen?',
    addOrg: 'Organisation hinzufügen',
    addTeam: 'Team hinzufügen',
    searchTeams: 'Teams durchsuchen',
    searchOrgs: 'Organisationen durchsuchen',
    downgradeRoleWarning: 'Achtung, wenn Sie Ihre Rolle ändern, verlieren Sie möglicherweise den Zugriff auf einige Funktionen. Sind Sie sicher, dass Sie fortfahren möchten?',
    vSTAGELoginScreen: 'vSTAGE Login Ansicht',
    noOrgs: 'Keine Organisationen',
    noTeams: 'Keine Teams',
    confirm: 'Bestätigen',
    userRemoved: 'Der Benutzer wurde entfernt',
    confirmRemoveFrom: 'Sind Sie sicher, dass Sie "{name}" von "{itemName}" entfernen möchten?',
    userUpdated: 'Benutzer aktualisiert',
    alwaysShowLabelText: 'Label immer anzeigen',
    OpenPopup: 'Popup öffnen',
    Behaviour: 'Verhalten',
    stateSetterText: `Die möglichen Zustände sind wie folgt:<br />
- Aktiv (a): Das Objekt ist derzeit aktiv und in Betrieb.<br />
- Verborgen (h): Das Objekt ist verborgen und für Benutzer nicht sichtbar.<br />
- Verarbeitung (p): Das Objekt wird verarbeitet oder aktualisiert.<br />
- Inaktiv (i): Das Objekt ist inaktiv und kann nicht heruntergeladen oder verwendet werden.<br />`,
    reloadStatus: 'Status neu laden',
    me: 'ich',
    Visibility: 'Sichtbarkeit',
    NoPermissionUpdateAssembly: 'Sie haben keine Berechtigung, diese Gruppe zu bearbeiten',
    positioning: 'Positionierung',
    stateSetterHint: '<b>In Verarbeitung:</b> Das Objekt wird im Moment verarbeitet, es wird in vSTAGE nicht auftauchen, bis der Prozess beendet ist. Dies geschieht nur beim Initial-Import.<br />' +
        '<b>Verborgen:</b> Das Objekt wird in vSTAGE nicht mehr zur Auswahl stehen, aber es wird immer noch in Präsentationen auftauchen, wo es früher mal platziert wurde.<br />' +
        '<b>Inaktiv:</b> Das Objekt ist in vSTAGE nicht platzierbar und es wird auch nicht bestehenden Präsentation angezeigt.<br />' +
        '<b>Aktiv:</b> Das Objekt ist platzierbar und es wird in den Präsentationen angezeigt.',
    itemState: {
        a: 'Aktiv',
        h: 'Verborgen (in vSTAGE nutzbar)',
        p: 'In Verarbeitung (in vSTAGE nicht nutzbar)',
        i: 'Inaktiv (in vSTAGE nicht nutzbar)',
    },
    currentSfxDataProcess: 'Aktueller 3D-Daten Prozess',
    noProcessRunning: 'Derzeit läuft kein Prozess',
    sfxDataLogHistory: '3D-Daten Log History',
    abortedConfirm: 'Verstanden und diese Nachricht entfernen',
    importAbortedMessage: 'Der Prozess wurde gestoppt. Wenn Sie die gemachten Änderungen rückgängig machen möchten, können Sie dies jetzt tun.',
    'Cleanup after abort': 'Ihr Task wurde abgebrochen. Das System entfernt nun alle CAD und temporäre 3D Dateien. Das kann einige Minuten dauern.',
    abortingPipelineTask: 'Ihr Task wird abgebrochen...',
    notYetStarted: 'Ihr Prozess wurde der Pipeline-Queue hinzugefügt und wird sobald wie möglich gestartet. Sie können das Fenster dennoch schliessen.',
    processingState: 'Prozess-Status',
    abortPipelineTask: 'Task abbrechen',
    abortPipelineTaskConfirm: 'Sind Sie sicher, dass Sie den Task abbrechen möchten? Dies kann nicht rückgängig gemacht werden. Der Task wird abgebrochen und alle CAD-Dateien werden gelöscht. Sie werden das Objekt manuell auf einen vorherigen Stand zurücksetzen müssen.',
    showPrivateTeams: 'Private Teams anzeigen',
    instanceMapperAlert: 'Achtung: Wenn Sie den Namen eines 3D Bauteils ändern, wird das der neue Identifier sein, mit dem MetaDaten appliziert werden,  oder im Fall eines Updates mit einer CAD Datei, wie die Namen verglichen werden. Falls dies nicht Ihre Absicht ist, nutzen Sie statt dessen DisplayName.',
    instanceMapperHinty: 'Auf der linken Seite können Sie die Eigenschaft des 3D Bauteils auswählen, die Sie updaten möchten, und auf der rechten Seite die Spalte aus Ihrer Datenquelle, die den Wert für das 3D Bauteil enthält. Hierbei sind auch Sachen wie spalte1_spalte2 möglich.',
    uploadMetaFile: 'Meta-Datei hochladen',
    metaDataUpdaterHint: 'Wenn Sie den 3D-Teilen Meta-Infos anhängen möchten wie z.B. Material, Farbe, etc., können Sie dies hier tun.',
    instanceUpdaterHint: 'Wenn Sie beispielsweise die Namen der 3D-Teile aktualisieren möchten, können Sie dies hier tun.',
    haveToPinFirst: 'Sie müssen zuerst das Panel anpinnen',
    partLegendHint: 'Damit dieser Block funktioniert, müssen in vSTAGE 3D-Teile als stücklistenrelevant markiert werden, dann werden in diesem Block die markierten Teile aufgelistet. Zudem kann diese Liste für den Word-Export genutzt werden.',
    HideExamples: 'Beispiele ausblenden',
    ShowExamples: 'Beispiele zeigen',
    ShowFileExamples: 'Datei-Beispiele zeigen',
    ShowRegexExamples: 'Regex-Beispiele zeigen',
    ExamplePayload: 'Beispiel Payload',
    UpdateMetaDataInfo: `Meta-Daten für 3D-Elemente aktualisieren. Das wird Metasets anhängen und Werte für die Metafields setzen.`,
    makeCollapsible: 'Collapsible machen',
    SetByTemplate: 'Vom Template vorgegeben',
    saveContent: 'Inhalte auch speichern',
    mfaLoginFailed: 'Das hat leider nicht geklappt, bitte versuchen Sie es erneut.',
    newLogin: 'Neues Login',
    legacyLogin: 'Altes Login',
    default: 'Standard',
    rulesBased: 'Regelbasiert',
    isPreSelected: 'Default Selection',
    Suggestion: 'Vorschlag',
    FindInstances: 'Instanzen finden',
    SelectUnselectAll: 'Alle selektieren / deselektieren',
    MultiEditing: 'Mehrfach-Bearbeitung',
    removeFromAllItems: 'Von allen Objekten entfernen',
    useRegexInfo: 'Wenn das originale Bauteil abc_v_5 heisst und das aktualisierte nun abc_v_6, dann braucht es einen Regex, der dafür sorgt, dass _v_5 ignoriert wird und somit abc_v_6 die neuere Version von abc_v_5 darstellt.',
    useRegex: 'Regex verwenden',
    useSmallImages: 'Verkleinerte Bilder verwenden',
    publicWarning: 'Achtung: wenn Sie dies publizieren, wird der Inhalt dieser Präsentation öffentlich zugänglich sein! Sie können die Veröffentlichung jederzeit rückgängig machen.',
    back: 'zurück',
    keepLoggingDisabled: 'Logging dauerhaft deaktivieren',
    EditMode: 'Editiermodus',
    TestMode: 'Testmodus',
    LogDisabled: 'Logging deaktiviert',
    ModeQuestion: 'In welchem Modus möchten Sie fortfahren?',
    vformMode: {
        production: 'Live',
        test: 'Test'
    },
    askForTestOrLiveMode: 'Beim Laden fragen, ob die Präsentation im Test-Modus (kein Logging) oder Live-Modus (Logging) gestartet werden soll',
    NewLogAttachedSaveIt: 'Wir haben für Sie ein neues Log angehängt. Sie sollten das Formular jetzt speichern.',
    showInline: 'Auf derselben Zeile',
    noQuestion: 'Ohne Frage',
    videoFileNotFound: 'Videodatei nicht gefunden',
    useComponentLogs: 'Komponenten-logs verwenden, wo verfügbar',
    renderGlobalPanels: 'Globale panels auch drucken',
    logNoAccess: 'Sie haben nicht die notwendige Berechtigung um das verknüpfte Log zu laden',
    logNotFound: 'Das Log konnte nicht gefunden werden',
    logIsEmpty: 'Das Log beinhaltet keine Daten',
    PDFReport: 'PDF Report',
    deleteAllSelected: 'Ausgewählte Dateien löschen',
    selectUnselectAll: 'Alle sichtbaren (un)selektieren',
    showLogEntries: 'Bisherige Logeinträge anzeigen',
    Unknown: 'Default language',
    instanceMapInfo: 'Wählen Sie hier, welche Ihrer Spalten welches Feld des Bauteils aktualisieren soll.',
    selectIdentifier: 'Spalte, die ein Bauteil identifiziert',
    inFile: 'In der Datei',
    onvHUBInstance: 'Instanz auf vHUB',
    mapData: 'Daten mappen',
    PostProcessingForInstance: 'Format für Daten-Datei auswählen',
    alwaysStartCollapsed: 'Zusammengeklappt anzeigen',
    upAxis: 'Up axis',
    OverallComplexity: 'Eingestellter Detailgrad, nur für asm, prt, sldasm, CATProduct, STEP und jt',
    errorMessages: {
        404: 'Diese Seite wurde nicht gefunden.',
        401: 'Sie haben keine Berechtigung, diese Seite anzuzeigen.'
    },
    convertToNewVersion: 'In Storage Version umwandeln',
    resetStyling: 'Styling zurücksetzen',
    applyForAllSteps: 'Auf alle Steps anwenden',
    resetAll: 'Alles zurücksetzen',
    showInstanceViewer: 'Instanzen-Viewer anzeigen',
    backToFrontPage: 'Zurück zur Startseite',
    NoSummaryInEditMode: 'Keine Zusammenfassung im Bearbeitungsmodus',
    Summary: 'Zusammenfassung',
    EditForm: 'Bearbeiten',
    Question: 'Frage',
    hideBottomBar: 'Fussblock verstecken',
    excludeFromGraph: 'Aus Transitionen ausschliessen',
    autoFit: 'Automatische Höhe',
    pinToTop: 'Oben anheften',
    pinToTopLeft: 'Oben Links anheften',
    pinToTopRight: 'Oben Rechts anheften',
    pinToLeft: 'Links anheften',
    pinToRight: 'Rechts anheften',
    pinToBottom: 'Unten anheften',
    pinToBottomLeft: 'Unten Links anheften',
    pinToBottomRight: 'Unten Rechts anheften',
    clearPin: 'Pin entfernen',
    ThemeColor: 'Theme Farbe',
    Images: 'Bilder',
    Videos: 'Videos',
    youWantToReplace: 'Das Objekt {itemName} existiert bereits. Sind Sie sicher, dass Sie es ersetzen möchten?',
    HideBottomBar: 'Bottom Bar verbergen',
    hasBorderRadius: 'Abgerundete Ecken',
    noTopPadding: 'Abstand am oberen Rand entfernen',
    LoadAmountOfParts: 'Anzahl Teile laden',
    VIEWERS: 'VIEWER',
    EDITORS: 'EDITOREN',
    yourMediaAssets: 'Ihre Medien-Assets',
    MediaAssets: 'Medien-Assets',
    VMUsage: 'Pipeline Nutzung (3D Import)',
    numberOfEditors: 'Anzahl Editoren',
    numberOfViewers: 'Anzahl Viewer',
    Users: 'Nutzer',
    usedInstances: 'Verwendete Instanzen',
    CurrentItems: 'Aktuelles',
    components: 'Komponenten',
    yourComponentLimit: 'Ihre Komponenten-Limite',
    usedComponents: 'Verwendete Komponenten',
    ScalingUnits: 'Skalierungseinheit',
    NewestProjects: 'Neuste Projekte',
    NewestAssemblies: '3D-Objekte',
    pipelineErrorMsg: 'Wir haben leider ein temporäres Problem festgestellt und wurden automatisch darüber informiert. Unser Team arbeitet an einer Lösung und wird Ihren Import anschließend fortsetzen. Vielen Dank für Ihr Verständnis.',
    GlobalSettings: 'Globale Einstellungen',
    applyForAllItems: 'Auf alle Objekte anwenden',
    yourDataGetsConverted: 'Ihre 3D-Daten werden nun mit dem neuen Format erweitert, Sie erhalten eine Email, sobald dieser Prozess abgeschlossen ist.',
    lodLevel: {
        0: 'Nur hohe Qualität (lod 0)',
        1: 'Hohe und mittlere Qualität (lod 0 und 1)',
        2: 'Hohe, mittlere und niedrige Qualität (lod 0 - 2)',
        3: 'Hohe, mittlere, niedrige und extra-niedrige Qualität (lod 0 - 3)'
    },
    showingAllPivotsInDropdown: 'Das Dropdown beinhaltet nun alle Pivot-Positionen',
    restoreVersionConfirm: 'Sind Sie sicher, dass Sie das Objekt auf diese Version zurücksetzen möchten?',
    addGlbFiles: 'GLB format hinzufügen',
    showPreview: 'Vorschau anzeigen',
    VersionsBackups: 'Versionen/Backups',
    LodLevels: 'Anzahl Komplexitätsstufen',
    removeTheHull: 'Hülle entfernen',
    removeAllSmallParts: 'Kleinstteile entfernen',
    Simplify: 'Vereinfachen',
    MergeParts: 'Teile mergen',
    RemoveParts: 'Teile entfernen',
    Advanced: 'Für Fortgeschrittene',
    Corrections: 'Korrekturen',
    stringSearch: 'Suche nach Namen',
    metaSearch: 'Suche in Meta-Informationen',
    showMetaValues: 'Meta-Daten anzeigen',
    showFlat: 'Nur Gefilterte anzeigen',
    rootNodeFile: 'Root-Datei',
    lod: 'LOD-Stufen',
    outputFormats: 'Formate',
    files: 'Dateien',
    Korrekturen: 'Korrekturen',
    VideoSizeHint: 'Für Videos über 20MB Grösse empfehlen wir einen Streaming-Service wie Vimeo oder Youtube zu nutzen, um die Lade-Performance zu optimieren',
    VideoHint: 'Sie finden die Video ID normalerweise in der URL Ihres Browsers',
    YourIdHere: 'Video ID hier',
    VideoId: 'Video id',
    EmbedCode: 'Embed code',
    state: 'Status',
    startsAt: 'Gültig ab',
    expiresAt: 'Gültig bis',
    noLicense: 'Keine Lizenz',
    licenseValid: 'Gültig',
    licenseExpired: 'Abgelaufen',
    licenseInvalid: 'Ungültig',
    licenseType: 'Lizenztyp',
    licensesAvailable: 'Lizenzen verfügbar',
    selectLicense: 'Lizenz auswählen…',
    assign: 'Zuweisen',
    assigning: 'Wird zugewiesen…',
    noLicensesAvailable: 'Keine freien Lizenzen für diese Organisation verfügbar.',
    removeLicense: 'Lizenz vom Benutzer entfernen',
    DownloadAll: 'Alle herunterladen',
    embedOnlyIfPublished: 'Der Einbettungs-Link erscheint hier, wenn das Projekt publiziert wurde',
    RestartOrGoHome: 'Möchten Sie eine neue Session beginnen oder zum Anfang zurückkehren?',
    GoTofirstslide: 'Zum Anfang zurückgehen',
    resetSession: 'Session zurücksetzen',
    theRequestedResourceWasNotFound: 'Die angeforderte Resource konnte nicht gefunden wurden.',
    SensorDisplay: 'Sensor Darstellung',
    numbers: 'Numerische Werte',
    SelectSensor: 'Sensor auswählen',
    webappPackage: 'Webapp Typ',
    attachNewLog: 'Neues Log anhängen',
    disableLoggingForThisSession: 'Logging für diese Sitzung deaktivieren',
    yourCameraIsntWorkingTryThis: 'Andere Kamera verwenden? Klicken Sie hier.',
    changeCamera: 'Kamera auswählen',
    selectedCamera: 'Ausgewählte Kamera',
    FullScreen: 'Aktueller Bildschirm',
    organizationsAndTeams: 'Organisationen und Teams',
    personalData: 'Persönliche Daten',
    fitToContent: 'Fit to content',
    alwaysKioskMode: 'Immer im Kioskmodus anzeigen',
    alwaysHideBottomBar: 'Fussleiste immer ausblenden',
    baseProject: 'Basis-Projekt',
    goToApp: 'Applikation aufrufen',
    reloadMessage: 'Der Inhalt wird neu geladen',
    kioskLeaveHint: 'Um den Kioskmodus zu verlassen, öffnen Sie das Sidepanel und halten Sie für 10s auf den Titel ({title}) geklickt, bis die Steuerelemente wieder auftauchen',
    addExisting: 'Bestehenden verwenden',
    create: 'Erstellen',
    resetColor: 'Farbe entfernen',
    pleaseSelectAType: 'Bitte wählen Sie einen Typ aus',
    publishHint: 'Die Webapp wird nun publiziert. Sie werden eine Email erhalten, sobald dieser Prozess abgeschlossen ist.',
    webappAutoPublishHint: 'Ihre Webapp wird gerade publiziert und ist in einigen Minuten bereit. Sie erhalten eine E-Mail, sobald der Vorgang abgeschlossen ist.',
    webappAutoPublishDoneHint: 'Ihre Webapp ist jetzt publiziert und bereit.',
    setBackToDefault: 'Standardwert wiederherstellen',
    deleteValue: 'Wert löschen',
    setValueToEmpty: 'Leeren Wert setzen',
    clearValue: 'Wert zurücksetzen',
    AdvancedFeatures: 'Erweiterte Funktionen',
    open: 'Öffnen',
    comingSoon: 'Coming soon',
    embedInLMS: 'In LMS einbetten',
    sendAsLink: 'Als Link senden',
    sureLeavePresentation: 'Sind Sie sicher, dass Sie die Präsentation verlassen möchten? Alle Fortschritte werden verloren gehen, sofern Sie die Präsentation nicht abgeschlossen haben.',
    IdentifierFieldIsRequired: 'Identifier ist erforderlich',
    addNextButtonForAllSteps: 'Weiter-Button für alle Steps hinzufügen',
    alignment: 'Ausrichtung',
    qrCameraView: 'QR Kamera Ansicht',
    addBackgroundColor: 'Hintergrundfarbe hinzufügen',
    setKioskMode: 'Kioskmodus aktivieren',
    RefreshForm: 'Formular neu laden',
    noImageSelected: 'Kein Bild ausgewählt',
    noVideoSelected: 'Kein Video ausgewählt',
    noAudioSelected: 'Kein Audio ausgewählt',
    noPdfSelected: 'Kein PDF ausgewählt',
    currentProject: 'Aktuelles Projekt',
    leavePresentation: 'Präsentation verlassen',
    vformProjectLinkerHelptext: 'Wenn Projekte bereits einem Form zugewiesen wurden, werden sie hier nicht erscheinen. Es ist nur ein Form pro Projekt möglich.',
    wrongQrCode: 'Falscher QR-Code',
    hasNextButtonOnEmptySlide: 'Has next button on slide without step',
    heightInPercent: 'Höhe in Prozent',
    pleaseChooseAPresentation: 'Wählen Sie eine Präsentation aus',
    formSettings: 'Einstellungen',
    CreateQrCode: 'QR Code erstellen',
    SelectQrCode: 'QR Code auswählen',
    NoneSelected: 'Nichts ausgewählt',
    addLoggingTable: 'Logging-Tabelle erstellen',
    hasNextButton: 'Hat einen "weiter"-Button',
    addStep: 'Step hinzufügen',
    emphasized: 'hervorgehoben',
    showAsTiles: 'als Kacheln anzeigen',
    showAsTile: 'als Kachel anzeigen',
    showAsPercentage: 'in Prozenten',
    isUserIdentifierHint: 'Damit die Daten aus dieser vForm in eine Logtabelle eingetragen werden können, benötigt es exakt ein Feld, das den Nutzer identifiziert. Aktivieren Sie den "IDENTIFIER" beim Feld, welches den Nutzer identifiziert (z.B. Personalnummer).',
    isUserIdentifier: 'Identifiziert den Nutzer',
    validateCorrectness: 'Korrektheit prüfen',
    isRequired: 'Ist erforderlich',
    projectFilesNotAvailable: 'Die Daten für dieses Projekt sind nicht auf dem Server. Bitte pushen Sie Ihr lokales Projekt auf den Server und versuchen Sie es dann erneut.',
    vFormProjectHint: 'Die Bestandteile eines vForms beziehen sich auf Slides eines Projekts. Daher wird nicht empfohlen, das Projekt zu wechseln oder zu entfernen, ansonsten müssen die Slide-Referenzen manuell angepasst werden. Ein vForm kann nur mit einem einzigen Projekt verknüpft sein.',
    addTranslation: 'Übersetzung hinzufügen',
    outputFormatsHelp: "Für Exporte zu MS Guides/Hololens das GLB-Format ist zwingend notwendig. Wenn mehr Ausgabe-Formate ausgewählt sind, kann sich der Import-Prozess z.T. erheblich verlängern.",
    OutputFormats: "Ausgabe-Formate",
    assemblyIsLocked: 'Dieses Objekt kann nicht bearbeitet werden, während gerade eine Version erstellt, wiederhergestellt oder gelöscht wird.',
    versioningProcessStarted: 'Der Sicherungsprozess ist gestartet. Sie werden eine Email erhalten, sobald der Prozess abgeschlossen ist.',
    makeAVersionFirst: 'Es ist empfehlenswert, vorher eine Sicherheitskopie anzulegen. Nach Ende dieses Prozesses erhalten Sie eine Email. Dieser Prozess kann je nach Grösse des 3D-Objekts mehrere Stunden dauern. Update-Prozesse ohne vorherige Sicherheitskopie auf eigenes Risiko.',
    restoreVersion: 'Auf diese Version zurücksetzen',
    deleteVersion: 'Diese Version löschen',
    previousSelection: 'Vorherige Auswahl',
    Update3dHint: 'This is a first version of the 3d data update. Make sure the items you want to keep in your CAD or other file have the same name like before or the element and its child components will be deleted.',
    Update3dData: '3D-Daten aktualisieren',
    teamsNotMatching: 'Achtung, dieses Item ist nicht für alle Teams zugänglich. Fehlendes Team: ',
    editFile: 'bearbeiten',
    duplicateFile: 'kopieren',
    createUpdateDefaultJson: 'create/update default json',
    instanceLocalValueUsesGlobalValueFromAsset: "No value set. Will use global value from asset",
    assetGlobalValueUsesDefaultValue: "No global value set. Using default value.",
    TileButtons: {
        imgvid: 'Images/Videos/Sound',
        webapp: 'Webapp',
        app: 'App',
        node: 'Node',
        material: 'Material',
        filter: 'ExportProfile',
        text: 'Text',
        model: '3D-Element',
        form: 'vForm',
        qrcode: 'QR-Code',
        report: 'Report',
        sensor: 'Sensor',
        feed: 'Feed',
        scenery: 'Szene',
        assembly: '3D-Gruppe',
        link: 'Link',
        media: 'Media',
        helper: 'vHelper'
    },
    LoadStats: 'Kennzahlen laden',
    importAssetViaCSV: 'Assets via CSV importieren',
    importLog: 'Import-Log',
    gotIt: 'Verstanden',
    cookieNotification: 'Durch den Klick auf den Login-Button erklären Sie sich mit Cookies einverstanden. Die' +
        ' Webapplikation funktioniert ohne den Einsatz von Cookies derzeit nicht.',
    gdpr_link: 'Datenschutzerklärung',
    Accept: 'Annehmen',
    Deny: 'Ablehnen',
    gdprExplanation: 'Mit Klick auf "annehmen" akzeptiere ich die obenstehende Datenschutzerklärung.<br />Beim' +
        ' Klick auf "ablehnen" werden Sie automatisch ausgeloggt.',
    gdprHint: 'Um vHub nutzen zu können, müssen Sie die folgende Datenschutzerklärung akzeptieren:',
    gdpr: gdpr_de,
    saas_agb: saas_agb_en,
    saas_services: saas_services_en,
    RowLifetime: 'Row Lifetime',
    Days: 'Tage',
    Hours: 'Stunden',
    Minutes: 'Minuten',
    Seconds: 'Sekunden',
    usePicker: 'Picker-Tool verwenden',
    manualEntry: 'Manueller Eintrag',
    noFilterData: 'In der ausgewählten Spalte sind keine Daten vorhanden, um zu filtern.',
    pwdConditions: {
        atLeastOneUppercaseLetter: 'Ein Grossbuchstabe',
        atLeastOneDigit: 'Eine Zahl',
        atLeastOneSpecialCharacter: 'Ein Sonderzeichen: {characters}',
        atLeastCharacters: 'Länge zwischen {min} und {max} Zeichen',
    },
    repeatPassword: 'Passwort wiederholen',
    showPassword: 'Passwort anzeigen',
    vmExplanation: 'Die virtuelle Maschine verarbeitet Ihre Daten',
    selectVM: 'Virtuelle Maschine auswählen',
    StorageUsage: 'Storage-Auslastung',
    LoadStorageUsage: 'Storage-Auslastung anzeigen',
    stopFeed: 'Stop feed',
    startFeed: 'Start feed',
    restartFeed: 'Restart Feed',
    getFeedStatus: 'Feed status',
    uploadvStageProject: 'Laden Sie zuerst ein Projekt von vStage hoch, um es hier zu verlinken.',
    noDataYet: 'Noch keine Objekte vorhanden?',
    permissions: {
        logs: 'logs',
        organization: 'Organisation',
        general: 'Allgemein',
        form: 'vForm',
        user: 'Benutzer',
        metaset: 'MetaSet',
        team: 'Team'
    },
    a: 'aktiv',
    h: 'verborgen',
    p: 'in Arbeit',
    i: 'inaktiv',
    m: 'in Wartung',
    createNewAssetBundle: 'Neues Asset Bundle',
    UseMetaSetValuesForPivots: 'Verwende für lokale Korrekturen das Feld "Bevorzugte Pivots" im Meta Set sfx.asset.transform (3D Transforms)',
    DefinePivotCorrections: 'Pivot Korrekturen',
    keepOriginalNamesAlert: 'Achtung: wenn diese Option angewählt ist, wird die resultierende Datei in vSTAGE nicht nutzbar sein',
    keepOriginalNames: 'Original-Namen beibehalten',
    centerPivots: 'Pivots zentrieren',
    pivotPlacement: 'Pivots-Position (Drehpunkt)',
    pivotComment: 'Source ist der Standard-Zustand, d.h. die Pivots werden von der Datei übernommen und nicht geändert',
    isPreview: 'Ist das verwendete Vorschaubild',
    setAsPreview: 'Als Vorschaubild verwenden',
    valueCopiedToClipboard: 'Der Wert wurde in Ihre Zwischenablage kopiert',
    New: 'Neu',
    DefineMerging: 'Merging-Gruppen definieren',
    State: 'Status',
    ConnectionWaiting: 'Die Internetverbindung ist langsam, bitte warten.',
    ConnectionError: 'Die Verbindung zum Server konnte nicht aufgenommen werden, versuche zu verbinden.',
    RemoveMetaSetWarning: 'ACHTUNG: Wenn Sie ein Metaset von einem Objekt entfernen, werden auch alle auf dem Zielobjekt gesetzten Werte gelöscht.',
    AttachOrRemoveMetaSet: 'Metasets hinzufügen / entfernen',
    ADD: 'Hinzufügen',
    UpdateProcessStarted: 'Der Aktualisierungsprozess ist gestartet. Sie werden eine Bestätigung erhalten, sobald der Prozess abgeschlossen ist.',
    NoExportProfileAccess: 'Ihre Organisation scheint diesen Service noch nicht freigeschaltet zu haben. Kontaktieren Sie uns für mehr Informationen.',
    WillDeleteAllRows: 'ACHTUNG: Hierdurch werden alle sichtbaren Einträge in dieser Tabelle gelöscht!',
    for: 'für',
    AllowAccess: 'Zugriff freigeben',
    SelectOrganizations: 'Organisationen auswählen',
    UserCreationHint: 'Sie können nur Benutzer für Organisationen erfassen, bei denen Sie Administrator-Rechte besitzen.',
    Role: 'Rolle',
    AddEntry: 'Eintrag hinzufügen',
    limitAccess: 'Zugriff einschränken',
    fullAccessInOrganization: 'Freier Zugriff für<br />Organisations-<br />mitglieder',
    allowTeamAccess: 'Teamzugriff',
    isDefault: 'Ist Standardwert',
    Documentation: 'Documentation',
    SideEffectsDisclaimer: 'Interactive 3D Solutions by <a href="https://sideeffects.ch" target="_blank">Side Effects AG</a>',
    SignIn: 'Sign In',
    frontSloganRight: 'Start now.<br />Create your own<br />3D realtime',
    frontSloganLeft: 'Tomorrow\'s<br />3D Digital Twin<br />Cloud Platform. Now.',
    AssemblyProcessing: 'Für diese 3D-Gruppe läuft gerade ein Verarbeitungsprozess. Updates werden möglich sein, sobald dieser Prozess abgeschlossen ist.',
    UpdateSfxData: '3D-Daten aktualisieren',
    XMLUpdateStart: 'Daten aktualisieren',
    SpecifyColumns: 'Spalten-Auswahl',
    GetEmailNotification: 'Per Email benachrichtigt werden',
    MetaUpdateMode: 'Beim <b>Zurücksetzen</b> werden sämtliche bestehenden Werte des gewählten Meta Sets vorher gelöscht<br />Beim <b>Überschreiben</b> werden bestehende abweichende Werte überschrieben<br />Beim <b>Erweitern</b> werden nur Werte erweitert, wo keine bestehenden Werte vorhanden sind',
    extend: 'erweitern',
    overwrite: 'überschreiben',
    reset: 'zurücksetzen',
    ChooseMaterialColumnIfOverwrite: 'Spalte Materialbezeichnung (überschreibt Standard-Werte, wenn ausgewählt)',
    ChooseColorColumnIfOverwrite: 'Spalte Farbbezeichnung (überschreibt Standard-Werte, wenn ausgewählt)',
    UploadMetaFile: 'Meta-Datei hochladen',
    UpdateMetaData: 'Meta-Daten aktualisieren',
    UpdateHierarchy: 'Hierarchie-Infos aktualisieren',
    MetaData: 'Meta-Daten',
    ActiveServices: 'Aktive Services',
    NameIsDefinitive: 'Achtung, der Name kann später nicht mehr geändert werden.',
    downloadAsCsv: 'Als CSV herunterladen',
    type: {
        backup: 'Sicherheitskopie',
        filter: 'Filter',
        Version: 'Version',
        ExportProfile: 'Exportprofil',
        exportProfile: 'Exportprofil',
        MetaSet: 'Meta Set',
        service: 'Service',
        team: 'Team',
        material: 'Material',
        user: 'User',
        Role: 'Rolle',
        scene: 'Szene',
        project: 'Projekt',
        VirtualMachine: 'Virtuelle Maschine',
        element: 'Element',
        texture: 'Textur',
    },
    willAlsoBeDeleted: 'Die folgenden verknüpften Elemente werden ebenfalls gelöscht',
    new: 'neu',
    finished: 'abgeschlossen',
    processing: 'in Verarbeitung',
    greatherThan: 'grösser als',
    equals: 'ist gleich',
    lessThan: 'weniger als',
    contains: 'enthält',
    FileSize: 'Dateigrösse',
    DownloadFbx: 'FBX Datei herunterladen',
    sourceProjectId: 'Projekt-ID',
    SourceCode: 'Quellcode',
    SelectedFile: 'Ausgewählte Datei',
    importSFX: '3D-Daten Import Konfiguration',
    PostProcessingForMeta: 'Format der Metadaten-Datei',
    metaSetName: 'Name des Metasets',
    metaSetMaterialField: "Metaset Feld für Material",
    matMapperLoadFromServer: "VOM SERVER LADEN",
    matMapperLoadFromXML: "VOM XML IMPORTIEREN",
    selectMaterialColumn: "Spalte für Material auswählen",
    applyMaterialFromMapper: "Apply Material Mapping",
    applyMaterialTaskStarting: "Startet den Prozess zum Anwenden des Materials. Bitte warten ...",
    metaDataUpdateTaskStarting: 'Startet den Prozess zum Aktualisieren der Metadaten. Bitte warten ...',
    instanceUpdateTaskStarting: 'Startet den Prozess zum Aktualisieren der 3D-Elemente. Bitte warten ...',
    metaDataUpdateTaskStarted: 'Der Prozess zum Aktualisieren der Metadaten wurde gestartet. Sie erhalten eine Email, sobald der Prozess abgeschlossen ist.',
    instanceUpdateTaskStarted: 'Der Prozess zum Aktualisieren der 3D-Elemente wurde gestartet. Sie erhalten eine Email, sobald der Prozess abgeschlossen ist.',
    applyMaterialTaskStarted: "Der Prozess zum Anwenden des Materials wurde gestartet. Sie erhalten eine Email, sobald der Prozess abgeschlossen ist.",
    materialName: "Material-Name des Kunden",
    materialRemapWith: "Material von vHUB",
    loadMaterials: "Materialien laden",
    saveMaterialMap: "Material-Zuweisung speichern",
    CreateNew: 'Neu erstellen',
    AllConnections: 'Alle Verknüpfungen',
    Disclaimer: 'Hinweis',
    ExportedProfiles: 'Exportierte Dateien',
    Preview: 'Vorschau',
    startProcess: 'Prozess starten',
    ExportProfiles: 'Exportprofile',
    createNewSFXFromExportProfile: 'Export starten',
    DefineProfile: 'Profil definieren',
    searchValues: 'Suchwerte',
    chooseType: '{type} auswählen',
    createExportProfile: 'Exportprofil erstellen',
    Mode: 'Modus',
    axisMultiplier: 'Rotation',
    pivotsField: 'Pivots',
    axisMultiplierDesc: 'Falls die Achse des Modells korrigiert werden muss, diese hier in Grad angeben (z.B.: x: 90, y: 180, z:0)',
    metaFilterInstructions: 'Für Zahlen:<br /><ul><li>gt (greather than/grösser als)</li><li>lt (less than/kleiner als)</li><li>eq (equal/gleich)</li></ul>Für Text:<br /><ul><li>eq (equal/gleich)</li><li>like (ähnlich wie)</li></ul><b>Beispiele:</b> "gt 5" oder "like *Chrom*" or "eq Metall"',
    inheritedValues: 'Geerbte Werte',
    globalValues: 'Globale Werte',
    localValues: 'Lokale Werte',
    importConfig: 'Import-Konfiguration',
    identifierColumn: 'ID Spalte',
    chooseModelIdField: 'Geben Sie die Spalte an, welche die Bauteilbenennungen beinhaltet.',
    filter3DItems: '3D-Elemente Filtern',
    filter3DItemsDescription: 'Wenn Sie nur bestimmte Teile Ihrer CAD-Daten importiert haben möchten, können Sie hier anhand Ihrer Meta-Daten Filtern',
    metaFileDataSet: 'Tabelle Meta-Daten',
    metaFile: 'Meta-Daten Datei',
    File: 'Datei',
    file: 'Datei',
    "File(s)": 'Datei(en)',
    thisCanTakeSeveralSeconds: 'Das kann bis zu {num} Sekunden dauern. Je nach Dateigrösse und Internetverbindung auch länger.',
    selectedFiles: 'Ausgewählte Datei(en)',
    removeFile: 'Datei entfernen',
    rootFile: 'Root-Datei',
    dataDescriptionFile: 'Metadaten-Datei',
    Filter: 'Filtern',
    Search: 'Suchen',
    pleaseChooseRoot: 'Bitte wählen Sie die Root-Komponente. (Hochgeladene Modelle müssen zwingend ein einzelnes Root-Element haben).',
    pleaseChooseDataFile: 'Bitte wählen Sie die Datei, welche Zusatzinformationen zu den einzelnen Elementen beinhaltet. (Derzeit werden nur XML-Dateien unterstützt, welche als Windchill Suchresultat exportiert wurden)',
    Back: 'Zurück',
    Forward: 'Vorwärts',
    folderStructureForUpload: 'Zip-File: es dürfen im Zip keine Ordner vorhanden sein, ausschliesslich Dateien',
    attentionUploadStartsProcess: 'Achtung: Upload startet den Import-Prozess sofort',
    importHierarchy: 'Import Hierarchie',
    cadConvert: 'CAD Daten konvertieren',
    packageImportV3: 'Paket V3 importieren',
    packageImportV3ChooseFile: 'Vorbereitetes CAD-Paket auswählen (.zip)',
    packageImportV3ZipOnly: 'Paketimport V3 akzeptiert nur ZIP-Dateien.',
    packageImportV3TooLarge: 'Das komprimierte Paket darf höchstens 20 GB gross sein.',
    packageImportV3NetworkError: 'Der Paket-Upload wurde unterbrochen. Bitte prüfen Sie die Verbindung und versuchen Sie es erneut.',
    packageImportV3Uploading: 'Paket wird hochgeladen',
    packageImportV3Queued: 'Warten auf Import-Worker',
    packageImportV3Completed: 'Import abgeschlossen',
    packageImportV3Failed: 'Import fehlgeschlagen',
    packageImportV3Counts: '{models} Modelle, {instances} Instanzen, {materials} Materialien',
    packageImportV3Stage_validating: 'Paket wird geprüft',
    'packageImportV3Stage_writing-files': 'Dateien werden geschrieben',
    'packageImportV3Stage_writing-database': 'Hierarchie und Metadaten werden geschrieben',
    packageImportV3Stage_finalizing: 'Import wird abgeschlossen',
    loadBefore: 'Zurück',
    loadMore: 'Mehr laden',
    jumpTo: 'Springe zu',
    initiallyUploaded: 'Datei hochgeladen',
    transferringData: 'Datentransfer zum Datenzentrum',
    transferComplete: 'Transfer zum Datenzentrum komplett',
    convertingData: 'Konvertierung der Daten',
    deliveringConvertedData: 'Auslieferung der konvertierten Daten',
    processingFinished: 'Verarbeitung abgeschlossen',
    yourFileIsFinishedProcessing: 'Ihre Daten wurden verarbeitet und sind nun unter "Verknüpfte Daten" verfügbar.',
    fileProcessingCannotUpload: 'Ihre Datei wird gerade verarbeitet – Sie können erst wieder eine neue Datei hochladen, wenn der Verarbeitungsprozess abgeschlossen ist.',
    stepEmailDisclaimer: 'Wenn Sie die Benachrichtigung an eine andere Email-Adresse als Ihre Account-Adresse gesendet bekommen möchten, können Sie hier eine Adresse angeben.',
    yourFileIsGettingProcessed: 'Ihre Datei wird nun verarbeitet. Sie werden eine Email erhalten, wenn die Verarbeitung abgeschlossen ist. Sie können dieses Browserfenster ohne Probleme schliessen.',
    stepFile: 'Step Datei',
    stepFileStatus: 'Step Datei Status',
    stepFileEmail: 'Email',
    reUploadFile: 'Neue Datei hochladen',
    pleaseWait: 'Bitte warten',
    stepFileProcessingDisclaimer: 'Wenn Sie die Verarbeitung starten, kann es je nach Dateigrösse bis zu 36h dauern, bis die Datei konvertiert ist.',
    uploadWaitDisclaimer: 'Bitte warten – bitte NICHT das Fenster schliessen oder neu laden, bis der Upload beendet ist.',
    startProcessing: 'Verarbeitung starten',
    fileProcessing: 'Dateiverarbeitung',
    Processing: 'In Bearbeitung',
    removePicture: 'Bild entfernen',
    changePicture: 'Bild ändern',
    editPicture: 'Bild bearbeiten',
    picture: 'Bild',
    addPicture: 'Bild hinzufügen',
    helperTextSfxTypes: '<b>vHelper</b><br />\n' +
        'Ein vHelper ist ein Modell, welches als Icon, für Navigationszwecke oder als Pointer eingesetzt wird, z.B. Pfeile, menschliche Figuren und so weiter.\n' +
        '\n' +
        '<br /><br /><b>Model</b><br />\n' +
        'Ein Model ist ein 3D Modell welches als einzelne Komponente behandelt wird, z.B. ein Feuerlöscher oder einen Mülleimer, den Sie in der Szene platzieren möchten.\n' +
        '\n' +
        '<br /><br /><b>Baugruppe</b><br />\n' +
        'Eine Baugruppe ist ein 3D-Modell welches aus mehreren Komponenten besteht und so verarbeitet wird, dass später mit einzelnen Unterkomponenten Daten verlinkt werden oder einzelne Komponenten ein- und ausgeblendet werden können.',
    app: 'App',
    webapp: 'Webapp',
    chooseMediaType: 'Medien-Typ auswählen',
    nodata: 'Für diese Ansicht sind derzeit keine Daten vorhanden',
    clearFilter: 'Filter leeren',
    from: 'von',
    until: 'bis',
    searchMode: 'Suchmodus',
    standard: 'Standard',
    exactMatch: 'Exakt gleich',
    similar: 'Ähnlich',
    beginsWith: 'Beginnt mit',
    doesNotContain: "Enthält nicht",
    justWaitAMinute: 'Bitte warten...',
    ExportAsPDF: 'Als PDF exportieren',
    basicConfiguration: 'Basis-Konfiguration',
    dataPreSelection: 'Daten-Vorauswahl',
    labelConfigurator: 'Beschriftungs-Konfigurator',
    additionalConfiguration: 'Weitere Konfigurationen',
    chartName: 'Name des Charts',
    chartDescription: 'Beschreibung',
    remainingCharacters: 'Verbleibende Zeichen',
    limitToNCharactersHint: 'Der Text darf maximal {num} Zeichen lang sein.',
    maxChars: 'Maximal {num} Zeichen.',
    maxSelected: 'Es können nur {num} Element(e) ausgewählt werden.',
    chooseLabelConfiguration: 'Wählen Sie aus, welche Daten im Tooltip angezeigt werden sollen.',
    linkToOriginalTable: 'Verknüpfte Tabelle',
    instances: 'Lokale Kopien',
    addData: 'Daten hinzufügen',
    addrow: 'Zeile hinzufügen',
    reloadMappingsWarningLoseChanges: "Sie werden alle ungespeicherten Änderungen verlieren. Fortfahren?",
    url: 'URL',
    owner: 'BesitzerIn',
    billingEmail: 'Rechnungs-Email',
    visibility: 'Sichtbarkeit',
    displayName: 'Display Name',
    maintext: 'Haupttext',
    editQrcode: 'QR Code bearbeiten',
    AccessDenied: 'Kein Zugriff',
    noAccess: 'Sie haben nicht die Berechtigung, auf diese Seite zuzugreifen',
    noAccessChangeOrg: 'Sie haben für die ausgewählte Organisation nicht die Berechtigung, auf diese Seite zuzugreifen',
    fieldname: 'Feldbezeichnung',
    insertBeforeField: 'Vor dem folgenden Feld einfügen',
    order: 'Reihenfolge',
    text: 'Text',
    audio: 'Audio',
    image: 'Bild',
    pdf: 'PDF',
    video: 'Video',
    font: 'Schriftart',
    string: 'Text',
    number: 'Zahl',
    timestamp: 'Zeitstempel',
    time: 'Zeit',
    typeToSelect: 'Tippen um zu filtern',
    index: 'Index',
    chooseSfxType: 'Bitte wählen Sie einen Typus aus.',
    chooseAppType: 'Bitte wählen Sie einen Typus aus.',
    choseFieldType: 'Bitte wählen Sie einen Typus aus.',
    choseDataSourceType: 'Bitte wählen Sie einen Typus aus.',
    choseQrcodeType: 'Bitte wählen Sie einen Typus aus.',
    deletePromptQuestion: 'Sind Sie sicher, dass Sie das gewählte Objekt löschen möchten?',
    deletePromptQuestionWithParams: 'Sind Sie sicher, dass Sie "{name}" löschen möchten?',
    unlinkPromptQuestion: 'Sind Sie sicher, dass Sie die gewählte Verknüpfung aufheben möchten? Lokale Daten, die mit dieser Verknüpfung zusammenhängen, gehen dabei möglicherweise verloren.',
    yes: 'Ja',
    abort: 'Abbrechen',
    addQrcode: 'QR Code erstellen',
    addqrcode: 'QR Code erstellen',
    username: 'Benutzername',
    password: 'Passwort',
    user: {
        role: 'Rolle',
    },
    data: {
        lastUpdate: 'Letzte Aktualisierung',
        name: 'Name',
        edit: 'Bearbeiten',
    },
    enternamehere: 'Name',
    cancel: 'Abbrechen',
    ok: 'OK',
    save: 'Speichern',
    Connect: 'Verknüpfen',
    edit: 'Edit',
    description: 'Beschreibung',
    media: 'Medien',
    name: 'Name',
    submit: 'Speichern',
    logout: 'abmelden',
    Created: 'Erstellt am',
    Updated: 'Aktualisiert am',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'Email',
    telnr: 'Telefon-Nummer.',
    withCountryCode: 'Mit Länder-Vorwahl (z.B. +41)',
    uploadfor: 'Datei hochladen für',
    ['Last change']: 'Letzte Änderung',
    Contributors: 'Beteiligte',
    sfxdata: "3D-Daten",
    qrcodes: "QR Codes",
    qrcode: "QR Code",
    datasources: 'Datenquellen',
    MetaPanel: 'Meta Informationen',
    sfxEditFile: '3D-Datei',
    mediaEditFile: 'Media-Datei',
    textEditFile: '.po Übersetzungs-Datei',
    localValuesDisclaimer: 'Lokale Werte überschreiben die globalen Werte für diese eine Instanz',
    assetMetaDisclaimer: 'Achtung: wenn Sie hier Werte überschreiben, werden diese überall dort ersetzt, wo dieses Asset in Verwendung und nicht durch lokale Werte überschrieben ist',
    uploadDisclaimer: 'Achtung: wenn Sie hier eine neue Datei hochladen, wird sie überall ersetzt, wo dieses Asset in Verwendung ist',
    onlySingleLinkingDisclaimer: 'Die untenstehenden Objekte können nur einmalig verlinkt werden.',
    showMorePivotPositions: 'Alle Pivot-Positionen anzeigen',
    pivot: {
        source: 'Original',
        top: 'Oben',
        left: 'Links',
        right: 'Rechts',
        center: 'Zentriert',
        base: 'Unten',
        front: 'Vorne',
        back: 'Hinten'
    },
    exportPrompt: {
        imageQuality: 'Bildqualität',
        imageQualityLevels: {low: 'Niedrig (Standard)', medium: 'Mittel', high: 'Hoch'},
        imageQualityHint: 'Höhere Qualität kann größere Dateien erzeugen. Die Qualität ist durch das Quellbild begrenzt.',
        exportFailed: 'Der Export ist fehlgeschlagen. Bitte erneut versuchen.',
        generatePartList: 'Bauteile-Liste-Tabelle am Schluss anhängen',
        pdfOptions: 'PDF Optionen',
        export: "Exportieren",
        import: 'Importieren',
        word: "Word",
        wordOptions: "Word Optionen",
        pdf: "PDF",
        PDFReport: "PDF Report",
        template: "Vorlage",
        autoGenerateLegend: "Legende generieren lassen",
        metaSet: "Meta Set",
        metaField: "Meta Field",
        download: "Herunterladen",
        pleaseSelectAlternativeNames:
            "Bitte wählen Sie ein Metaset und ein Metafeld aus, wenn Sie alternative Bauteilnamen für die Legende anzeigen möchten",
    },
    events: {
        organizationMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        instanceDeleteFailed: 'Das Löschen der Instanz ist fehlgeschlagen',
        instanceDataMetaValuesUpdated: 'Der Wert wurde aktualisiert',
        addedNextButtons: 'Die Buttons wurden hinzugefügt',
        instanceUpdated: 'Die Instanz wurde aktualisiert',
        metaValuesUpdated: 'Ein Meta-Wert wurde aktualisiert',
        tagUpdated: 'Der Tag wurde aktualisiert',
        metaFieldCreated: 'Ein Meta-Feld wurde erstellt',
        metaSetCreated: 'Ein Metaset wurde erstellt',
        appUpdated: 'Die Applikation wurde aktualisiert.',
        appCreated: 'Eine neue App wurde erstellt.',
        appDeleted: 'Die App wurde gelöscht',
        accessTokenCreated: 'Ein neuer persönlicher Zugriffstoken wurde erstellt.',
        accessTokenRevoked: 'Der persönliche Zugriffstoken wurde widerrufen.',
        appMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        dataSetCreated: 'Das Dataset wurde erstellt.',
        dataSetDeleted: 'Das Dataset wurde gelöscht',
        dataSetUpdated: 'Das Dataset wurde aktualisiert.',
        dataSourceMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        dataSourceCreated: 'Die Datenquelle wurde erstellt.',
        dataSourceDeleted: 'Die Datenquelle wurde gelöscht',
        dataSourceUpdated: 'Die Datenquelle wurde aktualisiert.',
        datasetMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        formUpdated: 'Das Formular wurde aktualisiert.',
        formCreated: 'Ein neues Formular wurde erstellt.',
        formDataCleared: 'Formulardaten wurden gelöscht.',
        mediaCreated: 'Ein neues Medien-Objekt wurde erstellt.',
        mediaDeleted: 'Das Medien-Objekt wurde gelöscht',
        mediaUpdated: 'Das Medien-Objekt wurde aktualisiert.',
        mediaMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        metaFieldDeleted: 'Das MetaField wurde gelöscht',
        metaFieldUpdated: 'Das MetaField wurde aktualisiert',
        organizationUpdated: 'Die Organisation wurde aktualisiert',
        organizationCreated: 'Die Organisation wurde erstellt.',
        organizationDeleted: 'Die Organisation wurde gelöscht.',
        pictureRemoved: 'Das Bild wurde entfernt.',
        projectCreated: 'Ein neues Projekt wurde erstellt.',
        projectDeleted: 'Das Projekt wurde gelöscht',
        projectUpdated: 'Das Projekt wurde aktualisiert.',
        projectMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        qrcodeCreated: 'Ein neuer QR-Code wurde erstellt.',
        qrcodeDeleted: 'Der QR-Code wurde gelöscht',
        qrcodeUpdated: 'Der QR-Code wurde aktualisiert.',
        qrcodeMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        reportCreated: 'Ein neuer Report wurde erstellt.',
        reportUpdated: 'Der Report wurde aktualisiert.',
        reportMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        sceneCreated: 'Eine neue Szene wurde erstellt.',
        sceneDeleted: 'Die Szene wurde gelöscht',
        sceneUpdated: 'Die Szene wurde aktualisiert.',
        sceneMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        sfxDataCreated: 'Ein neues 3D-Objekt wurde erstellt.',
        sfxDataDeleted: 'Das 3D-Objekt wurde gelöscht',
        sfxDataUpdated: 'Das 3D-Objekt wurde aktualisiert.',
        sfxDataMetaValuesUpdated: 'Der Wert wurde aktualisiert.',
        tagDeleted: 'Der Tag wurde gelöscht.',
        tagsAdded: 'Der Inhalt wurde getaggt',
        tagCreated: 'Der Tag wurde erstellt',
        tagsRemoved: 'Der Tag wurde entfernt',
        textUpdated: 'Der Text wurde aktualisiert.',
        textCreated: 'Der Text wurde erstellt.',
        userUpdated: 'Die Nutzerdaten wurden aktualisiert',
        userCreated: 'Ein neuer Nutzer wurde angelegt',
        metaValuesUnset: 'Der Meta-Wert wurde entfernt',
        materialsSaved: 'Materialien sind gespeichert',
    },
    backtooverview: 'Zurück zur Übersicht',
    projectloading: 'Projekt lädt',
    apploading: 'Applikation lädt',
    STATUS: 'STATUS',
    CONTRIBUTORS: 'ERSTELLT VON',
    entertitlehere: 'Titel hier eingeben',
    enterdeschere: 'Beschreibung hier eingeben',
    downloadType: '{type} herunterladen',
    createNewType: '{type} erstellen',
    selectedType: 'Ausgewähltes {type}',
    addNewType: '{type} hinzufügen',
    deleteType: '{type} löschen',
    createNewTypeFile: '{type} erstellen',
    updateType: '{type} aktualisieren',
    createNewApp: 'Neue App erstellen',
    createNewReport: 'Neue Statistik anlegen',
    createNewProject: 'Neues Projekt erstellen',
    createNewSfxdata: '3D-Daten importieren',
    updateSfxdata: '3D-Daten aktualisieren',
    createNewMedia: 'Neue Medien-Datei erstellen',
    createNewUser: 'Neuen Benutzer anlegen',
    accessTokens: 'Persönliche Zugriffstoken',
    createNewAccessToken: 'Neuen Zugriffstoken erstellen',
    accessTokenName: 'Name',
    accessTokenNamePlaceholder: 'z.B. MCP Server',
    accessTokenExpiresInDays: 'Gültig für (Tage)',
    accessTokenCreatedTitle: 'Zugriffstoken erstellt',
    accessTokenCreatedWarning: 'Kopiere diesen Token jetzt — er kann danach nicht mehr angezeigt werden.',
    accessTokenPrefix: 'Token',
    accessTokenExpiresAt: 'Läuft ab',
    accessTokenLastUsed: 'Zuletzt verwendet',
    accessTokenNeverUsed: 'Noch nie verwendet',
    accessTokenRevoke: 'Widerrufen',
    accessTokenNoTokens: 'Noch keine persönlichen Zugriffstoken vorhanden.',
    accessTokenRevokeConfirm: 'Diesen Token widerrufen? Alles, was ihn verwendet, funktioniert danach sofort nicht mehr.',
    copyToClipboard: 'In Zwischenablage kopieren',
    copiedToClipboard: 'Kopiert!',
    createNewMetaField: 'Neues MetaField anlegen',
    createNewMetaSet: 'Neues MetaSet anlegen',
    createNewOrganization: 'Neue Organisation erstellen',
    createNewText: 'Neuen Textblock erstellen',
    createNewQrCode: 'Neuen QR Code erstellen',
    createNewMaterialMapper: 'Neuer Material-Mapper',
    createNewForm: 'Neues Formular erstellen',
    SAVE: 'SPEICHERN',
    REMOVE: 'ENTFERNEN',
    makeCodePretty: 'Code formatieren',
    items: 'Objekte',
    imageupload: 'Bilddatei hierher ziehen oder klicken',
    fileupload: 'Datei hierher ziehen oder klicken',
    Media: "Medien",
    Datasets: "Datenquellen",
    ChooseProjectForApp: 'Wählen Sie ein Basis-Projekt für diese App',
    deletefield: 'FELD LÖSCHEN',
    Anumberbetween: 'Eine Zahl zwischen {num} und {num2}',
    duplicateFileError: 'Eine Datei mit dem Namen {fileName} existiert bereits. Bitte benennen Sie Ihre Datei um oder wählen sie eine andere Datei aus.',
    addnewfield: 'Neues Feld hinzufügen',
    addnewcolumn: 'Neue Spalte hinzufügen',
    savefield: 'Feld speichern',
    editfield: 'Feld "{field}" bearbeiten',
    fieldCannotBeEditedWhenData: 'Das Feld kann nicht bearbeitet werden, wenn in der Tabelle bereits Daten dazu befüllt sind.',
    NotANumber: 'Der angegebene Wert ist keine Zahl',
    createnew: 'Neu hinzufügen',
    filtering: 'Filtern',
    resources: 'Resourcen',
    library: "Bibliothek",
    addconnection: "Verknüpfung wird hinzugefügt",
    removeconnection: "Verknüpfung wird entfernt",
    LinkedData: 'Verknüpfte Daten',
    LocalLinkedItems: 'Verknüpfte Daten',
    localLinkedItems: 'Verknüpfte Daten',
    createNewDataSet: 'Neue Tabelle erstellen',
    createNewDataSource: 'Neue Datenquelle erstellen',
    forms: {
        isDefaultOrganization: 'Ist die Standardorganisation',
        default: 'Standard',
    },
    meta: {
        type: {
            int: 'Ganzzahl',
            str: 'Zeichenkette',
            json: 'JSON',
            float: 'Gleitkommazahl',
            enum: 'Aufzählung',
            dataset: 'Tabelle',
            datarow: 'Daten-Zeile',
            bool: 'Wahrheitswert',
            clr: 'Farbe',
            v2: 'Vektor 2',
            v3: 'Vektor 3',
            v4: 'Vektor 4',
            time: 'Zeit',
            datetime: 'Zeit und Datum',
            date: 'Datum',
            project: 'Projekt',
            password: 'Passwort',
            repeatPassword: 'Passwort wiederholen',
            xform3: 'Xform3',
            xform2: 'Xform2',
            email: 'Email',
            ip: 'IP',
            ipv6: 'Ipv6',
            uri: 'Uri',
            range: 'Bereich',
            asset: {
                feed: 'Feed',
                sensor: 'Sensor'
            },
        }
    },
    'Legacy project id': 'Legacy Projekt-ID',
    Type: 'Typ',
    'Last Update': 'Mut. Datum',
    Edit: 'Aktionen',
    delete: 'Löschen',
    assembly: '3D Gruppe',
    helper: 'vHelper',
    model: '3D Element',
    orgVisibilityTypes: {
        '0': 'Privat',
        '1': 'Öffentlich',
        '2': 'Organisationsübergreifend',
    },
    teamVisibilityTypes: {
        '0': 'privat',
        '1': 'öffentlich',
        '2': 'global (neue User werden autom. hinzugefügt)'
    },
    mediaCategory: {
        '0': 'Applikation',
        '1': 'Audio',
        '2': 'Schriftart',
        '3': 'Bild',
        '4': 'Nachricht',
        '5': 'Modell',
        '6': 'PDF',
        '7': 'Text',
        '8': 'Video',
    },
    vform: {
        legend: "Legende",
        legendPlaceholder: "Legenden-Platzhalter",
        noCaptionsDetected: "Keine Beschriftungen gefunden",
        partLegend: "Stückliste Legende",
        titleAlignment: "Titel Ausrichtung",
        textAlignment: "Text Ausrichtung",
        partLegendLoading: "Stückliste wird geladen",
        video: 'Video',
        audio: 'Audio',
        courseBlock: 'Course Nav',
        sendEmailToAddress: 'Send email to',
        Checkout: 'Checkout',
        HistoryBack: 'History back',
        FirstSlide: 'Erster Slide',
        LastSlide: 'Letzter Slide',
        FirstStep: 'Erster Step',
        LastStep: 'Letzter Step',
        formSummary: 'Formular Zusammenfassung',
        vimeo: 'Vimeo',
        youtube: 'Youtube',
        other: 'Anderes',
        embed: 'URL Einbetten',
        directEmbed: 'Direkt einbetten',
        upload: 'Direkter Upload',
        chart_line: "Line",
        chart_text: "Text",
        sensor: 'Sensordaten',
        codeSnippet: 'Code',
        translationMessage: "{key} übersetzung für: {content}",
        oldVersionMessage: "Sie haben eine vForm geöffnet, welche mit einer alten Version von vSTAGE erstellt wurde. Wenn Sie speichern, wird die vForm auf die neuste Version aktualisiert. Bitte prüfen Sie, ob alles wie gehabt funktioniert.",
        steps: "Steps",
        blocks: "Bausteine",
        button: "Button",
        login: "Login",
        logout: "Logout",
        editor: "Formular Editor",
        checkoutButton: "Checkout Button",
        preview: "Vorschau",
        headline: "Titel",
        website: "Website",
        singlechoice: "single choice",
        multichoice: "multi choice",
        textfield: "Text",
        shortanswer: "Texteingabefeld",
        helloworld: "Hallo Welt",
        shortLorem: "Text ...",
        longLorem: "Lorem ipsum ..",
        image: "Bild",
        qrcode: "QR Code",
        stepControl: "Step Control",
        projectSwitch: "Projekt-Switch",
        metaListFilter: "Meta List Filter",
        mediaLoader: "Medien-Anzeige",
        divider: "Trennstrich",
        verticalSpace: "Vertical Space",
        horizontalSpace: 'Horizontal Space',
        slide: "Slide",
        UnnamedStep: "Neuer Step",
        NoAction: "Keine Aktion",
        NextSlide: "Next Slide",
        GoToStep: "Go to Step",
        GoToSlide: "Go to Slide",
        newStep: "Neuer Step",
        properties: "Properties",
        stepProperties: "Step",
        cannotSelectStepsFromOldVform: "You will be able to select steps from this project once you convert it to the new vform version.",
        nextStepButtonsAdded: "'Next Button' was successfully added to each step",
        link: "Link",
        iframe: "iFrame",
        newTab: "Open in new tab",
        loseChangesWarning: "You will lose all your changes. Continue?",
        doNotShowDeleteElementConfirmation: "Diese Mitteilung nicht mehr anzeigen",
        publishButton: "Projekt publizieren",
        publishvformToAppMessage: "Publish started... You will receive an email with the outcome.",
        unpublishvformToAppMessage: "Unpublish started... You will receive an email with the outcome.",
        publishTragetWebAppRequired: "Please select target webapp.",
        selectTragetWebAppPlaceholder: "Select target webapp",
        unpublish: "Unpublish",
        republish: "Republish",
        listOfWebAppsWhereVformIsPublished: "Veröffentlicht in:",
        textArea: "Mehrzeiliges Textfeld",
        metaInfo: "Meta Info",
        partInfovStageOnly: "Part Info block is visible only in vStage",
        partInfo: "Bauteil-Info",
        selectInstanceFromScene: "You can select an instance to view more details",
        selectInstanceNotFound: "Selected Instance not found / no extra info",
        sureClearingFormData: "Are you sure you want to clear all form data?",
        clearFormData: "Clear Form Data",
        hotspots: "Hotspots",
        learningDot: "Hotspot",
        possibleAnswers: "Possible answers",
        correct: "Correct",
        learningDots: "Basu-Dots",
        addLearningDot: "Add Label",
        listMatchpanel: "Case 1",
        listMatchimage: "Case 2",
        listMatch: "List Match",
        listMatchTextInput: "List Match - Text Input",
        addHotspot: "Add Hotspot",
        hotspot: {
            popup: 'Popup',
            goto: 'Navigate'
        },
        buttonStyle: {
            Text: 'Text',
            Arrow: 'Arrow',
            TextAndArrow: 'Text & Arrow',
            TextAndIcon: 'Text & Icon'
        },
        buttonSizeMode: {
            auto: 'Auto (Inhaltsbasiert)',
            minheight: 'Mindesthöhe'
        },
        isMasterPanel: 'Is Global',
        localPanels: 'Local Panels',
        globalPanels: 'Global Panels',
        hideBottomBar: 'Hide Bottom Bar',
        applyLayoutPositionToAllSteps: 'Diese Position auf alle geeigneten Schritte anwenden',
        layoutPositionAppliedToAllSteps: 'Layout-Position auf alle geeigneten Schritte angewendet',
        autoFit: "Auto Fit",
        collapsible: "Collapsible",
        initiallyCollapsed: "Initial Collapsed",
        showHideSliders: "Show Additional options",
        noPin: "No pin",
        pinTop: "Pin Top",
        pinTopRight: "Pin Top Right",
        pinTopLeft: "Pin Top Left",
        pinLeft: "Pin Left",
        pinRight: "Pin Right",
        pinBottom: "Pin Bottom",
        pinBottomLeft: "Pin Bottom Left",
        pinBottomRight: "Pin Bottom Right",
        autoPlay: "Auto Play",
        loop: "Loop",
        templates: "Templates",
        missingTemplate: "Template fehlt oder wurde gelöscht. Wir empfehlen, das aktuell angehängte Template zu entfernen und ein neues auszuwählen.",
        removeTemplate: "Template entfernen",
        noTemplatesFound: "Keine passenden Templates gefunden.",
        viewAllTemplates: "Templates anzeigen/editieren",
        close: "Schliessen",
        templatePreviewer: "Template-Vorschau",
        templateAssetNotFound: "Template-Asset für Ihre Organisation nicht gefunden",
        templateEditor: "Template-Editor",
        templateType: "Template-Type",
        noTemplateSelected: "Kein Template ausgewählt.",
        templateIsEmpty: "Template-Name darf nicht leer sein.",
        templateOverwrite: "Sie sind dabei, ein vorhandenes Template zu überschreiben. Überall, wo dieses Template verwendet wird, wird es aktualisiert.",
        createNewTemplate: "Neues Template erstellen",
        selectTemplate: "Template wählen",
        saveTemplate: "Template speichern",
        saveChanges: "Änderungen speichern",
        renameTemplate: "Template umbenennen",
        deleteTemplateQuestion: 'Sind Sie sicher, dass Sie das Template "{templatename}" löschen möchten? Es wird für die gesamte Organisation gelöscht.',
    },

    isCorrectAnswer: "Ist korrekt",
    isChecked: "Ist ausgewählt",
    cclight: {
        notFound: "404 Seite nicht gefunden",
        notFoundMessage: "Seite wurde nicht gefunden. Bitte überprüfen Sie die URL oder wenden Sie sich an den Administrator.",
        unauthorized: "401 Nicht autorisiert",
        unauthorizedMessage: "Kein Zugriff – bitte wenden Sie sich an Ihren Administrator",
        goBack: "Zurück",
    },
    rotLocScaleSetterPrompt: "Bitte beachten Sie, dass dieses Widget nun dasselbe Koordinatensystem wie vSTAGE verwendet. Dadurch wird die Positionierung bei allen vSTAGE-Präsentationen entsprechend angepasst.",
    linkedDataMessage: "Sie haben soeben einen Sensor verknüpft, bitte vergessen Sie nicht, den Feed neu zu starten, damit die Sensordaten für dieses Bauteil gespeichert werden, wenn sie hereinkommen.",
    isMaterialHidden: "Dieses Material ist auf hidden gesetzt.",
    isMaterialInactive: "Dieses Material ist auf inaktiv gesetzt.",
    noMaterialSelected: "Kein Material ausgewählt",
    localMaterialPrompt1: "Material nur für dieses Bauteil ändern.",
    localMaterialPrompt2: "Die View zeigt möglicherweise nicht die aktuellen Werte an, da mehrere Instanzen ausgewählt sind. Deaktivieren Sie den Mehrfach-Bearbeitungsmodus, um die Daten für eine einzelne Instanz anzuzeigen.",
    globalMaterialPrompt: "Ändern Sie das Material überall dort, wo dieses Teil verwendet wird",
    multiInstanceEditingMode: "Mehrfach-Bearbeitungsmodus",
    rotLocScaleSetterDescription: "Dies wird nur in der Instanz gespeichert (d.h. nicht in allen Schrauben, sondern nur in dieser)",
    MATERIAL: "Material",
    TILING: "Tiling",
    COLOR: "Farbe",
    createAnchorPoint: 'Anchor Point erstellen',
    January: 'Januar',
    February: 'Februar',
    March: 'März',
    April: 'April',
    May: 'Mai',
    June: 'Juni',
    July: 'Juli',
    August: 'August',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'Dezember',
}
